import { Component, inject, OnInit, signal } from '@angular/core';
import { NewModalBodyComponent } from '../../../shared/new-modal-body/new-modal-body.component';
import { InvoicingService, ISaleStatus } from '../../../core/services/invoicing.service';
import { StoresService } from '../../../core/services/stores.service';
import { ToastNotificationsService } from '../../../core/services/toast-notifications.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TextInputComponent } from '../../../shared-with-client/text-input/text-input.component';
import { ButtonComponent } from '../../../shared-with-client/button/button.component';
import { IconComponent } from '../../../shared-with-client/icon/icon.component';
import { AlertComponent } from "../../../shared-with-client/alert/alert.component";
import { DropdownInputV2Component } from "../../../shared-with-client/dropdown-input-v2/dropdown-input-v2.component";

@Component({
    selector: 'app-cancel-invoice-modal',
    imports: [NewModalBodyComponent, TextInputComponent, ReactiveFormsModule, ButtonComponent, IconComponent, TranslatePipe, AlertComponent, DropdownInputV2Component],
    templateUrl: './cancel-invoice-modal.component.html',
    styleUrl: './cancel-invoice-modal.component.scss',
})
export class CancelInvoiceModalComponent implements OnInit {
    private invoicingService = inject(InvoicingService);

    private storesService = inject(StoresService);
    private toastNotificationsService = inject(ToastNotificationsService);
    private translateService = inject(TranslateService);
    private fb = inject(FormBuilder);

    public currentStore = toSignal(this.storesService.getActiveStore());

    public saving = signal<boolean>(false);

    public dialogRef = inject(DialogRef<any>);
    public data = inject(DIALOG_DATA) as { saleId: number, saleStatus: ISaleStatus, hasPayments: boolean };

    public paymentMethods = this.invoicingService.paymentMethods;

    public submitAttempted = signal<any>(false);
    public form: FormGroup;


    public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());
    public ISaleStatus = ISaleStatus;

    ngOnInit(): void {
        this.form = this.fb.group({
            reason: ['', Validators.required],
            refundPaymentMethod: [null, this.data?.hasPayments ? [Validators.required] : []],
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    submit(): void {
        this.submitAttempted.set(true);

        const isDraft = this.data.saleStatus === ISaleStatus.DRAFT;
        if (!isDraft && this.form.invalid) {
            return;
        }

        this.saving.set(true);
        console.log('isDraft:', isDraft)
        const action = isDraft
            ? this.invoicingService.deleteDraft(this.data.saleId)
            : this.invoicingService.cancelSale(
                  this.data.saleId,
                  this.currentStore().id,
                  this.form.value.reason,
                  this.form.value.refundPaymentMethod?.value,
              );

        action.subscribe({
            next: () => {
                this.toastNotificationsService.showToast(this.translateService.instant('GENERAL.savedSuccessfully'), 'success');
                this.dialogRef.close('yes');
            },
            error: (error) => {
                this.toastNotificationsService.showToast(error?.errMsg || this.translateService.instant('GENERAL.generalErrorMsg'), 'error');
                this.saving.set(false);
            },
        });
    }
}
